import axios from 'axios';

export class SemanticPrioritizer {
    constructor(selector, key) {
        document.querySelectorAll(selector).forEach(element => {
            element.onclick = event => {
                event.preventDefault();
                
                if (element.hasAttribute('priority')) {
                    element.removeAttribute('priority');
                }
                else {
                    element.setAttribute('priority', '');
                }

                element.parentNode.querySelectorAll('.priority-layover').forEach(child => {
                    if (child.getAttribute(key) !== element.getAttribute(key)) {
                        child.removeAttribute('priority');
                    }
                });

                axios.post('productpictures/toggle-priority', { id: element.getAttribute(key) });
            };
        });
    }
}